export default __webpack_public_path__ + "static/media/Unionhead.896e5cc8.svg";